import {
  takeLatest,
  takeLeading,
  put,
  select,
  all,
  call,
} from 'redux-saga/effects';
import axios from 'axios';
import {
  sendEmailFailure,
  sendEmailSuccess,
  sendTextFailure,
  sendTextSuccess,
} from './message.actions';
import {
  selectMessageValue,
  selectMessageTemplateId,
} from './message.selector';
import { MessageActionTypes } from './message.types';
import { selectDof } from '../flightData/flightData.selector';
import { selectCurrentUser } from '../user/user.selector';
import { selectCustomerData } from '../customers/customer.selector';
import { updateMessageData } from '../customers/customer.actions';

export function* sendEmail() {
  try {
    const message = yield select(selectMessageValue);
    const templateId = yield select(selectMessageTemplateId);
    const date = yield select(selectDof);
    const userAuth = yield select(selectCurrentUser);
    const customerData = yield select(selectCustomerData);
    const data = yield customerData.map((customer) =>
      customer.emailStatus === 'not sent' || customer.emailStatus === undefined
        ? customer
        : {}
    );
    let year = date.split('-')[0];
    let month = date.split('-')[1];
    let day = date.split('-')[2];

    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/sendgrid/sendemail',
      method: 'post',
      data: {
        user: userAuth.displayName,
        data: data,
        message: message,
        templateId: templateId,
        date: `${month}/${day}/${year}`,
        userAuth: userAuth,
      },
    });

    if (response && response.data.messageData.length > 0) {
      for (const customer of response.data.messageData) {
        yield put(updateMessageData(customer));
      }
    }
    yield put(sendEmailSuccess());
  } catch (error) {
    yield alert('Error occured while sending Email message');
    yield put(sendEmailFailure(error));
  }
}

export function* sendText() {
  try {
    const message = yield select(selectMessageValue);
    const templateId = yield select(selectMessageTemplateId);
    const date = yield select(selectDof);
    const userAuth = yield select(selectCurrentUser);
    const customerData = yield select(selectCustomerData);
    const data = yield customerData.map((customer) => {
      if (
        customer.textStatus === 'not sent' ||
        customer.textStatus === undefined
      ) {
        return customer;
      } else {
        return {};
      }
    });
    let year = date.split('-')[0];
    let month = date.split('-')[1];
    let day = date.split('-')[2];

    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/twilio/customerbyflight',
      method: 'post',
      data: {
        user: userAuth.displayName,
        data: data,
        message: message,
        templateId: templateId,
        date: `${month}/${day}/${year}`,
        userAuth: userAuth,
      },
    });

    if (response && response.data.messageData.length > 0) {
      for (const customer of response.data.messageData) {
        yield put(updateMessageData(customer));
      }
    }
    yield put(sendTextSuccess());
  } catch (error) {
    yield alert('Error occured while sending Text message');
    yield put(sendTextFailure(error));
  }
}

export function* onSendEmailStart() {
  yield takeLeading(MessageActionTypes.SEND_EMAIL_START, sendEmail);
}

export function* onSendTextStart() {
  yield takeLatest(MessageActionTypes.SEND_TEXT_START, sendText);
}

export function* messageSagas() {
  yield all([call(onSendEmailStart), call(onSendTextStart)]);
}
